module.exports = __webpack_public_path__ + "img/btn_tb_close.3ed9d2d6.svg";